import { render, staticRenderFns } from "./MatterProgramEvaluationDraggable.vue?vue&type=template&id=af01c3e6&scoped=true"
import script from "./MatterProgramEvaluationDraggable.vue?vue&type=script&lang=js"
export * from "./MatterProgramEvaluationDraggable.vue?vue&type=script&lang=js"
import style0 from "./MatterProgramEvaluationDraggable.vue?vue&type=style&index=0&id=af01c3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af01c3e6",
  null
  
)

export default component.exports